// @ts-nocheck
import { Icon } from '@iconify/react';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
// material
import { useTheme, styled } from '@mui/material/styles';
import { Box, Paper, Stack, Card, Button, Collapse, TextField, IconButton, Typography, GridLegacy as Grid  } from '@mui/material';

import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useEffect, useState } from 'react';
import LightboxModal from '../../../../../components/LightboxModal';


import Page from '../../../../../components/Page';
import { doc400 } from '../../../../userImage';
import DocPreview, { LoadingPreview } from './DocPreview';
import DocUploadDropzone from './DocUploadDropzone';
import { FDate } from 'src/constants/defaultValues';

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  padding: theme.spacing(12, 0)
}));


// ----------------------------------------------------------------------

export default function VerifyCode({handleUpdateDoc, isMobile, toast, doc, editable, closeModal, handleAddDoc, loading}) {
    
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

//   let [provider, setProvider] = useState('');
  let [expiryDate, setExpiryDate] = useState('');
//   let [policyNumber, setPolicyNumber] = useState('');
  let [file, setFile] = useState(null);
  let [fileId, setFileId] = useState(null);
  let   [currentFile, setCurrentFile] = useState(null);
  let   [fileOpen, setFileOpen] = useState(false);
  const [showError, setShowError] = useState(false);

  // let [cards, setCards] = useState([]);
  
  

  useEffect(()=>{
    if(doc && doc.id){
      if(doc.expiry_date) setExpiryDate(doc.expiry_date)
    }
  },[]);

  // const handleSubmit = e=>{
    
  //   if(cards.length>0){
  //     handleLicenses(cards);
  //   }else{
  //     toast('warning', 'Please add at least one card!')
  //   }
  // }
  const handleViewDoc = doc=>{
    setCurrentFile(doc.file);
    setFileOpen(true);
  }

  const handleSubmit = e=>{
    
      if(expiryDate){
        
        if(!file){
          toast('warning', 'Please select a valid document copy!')
          return;
        }
        if(expiryDate=='Invalid Date'){
          toast('warning', 'Please select a valid expiry date');
          return;
        }

        let today = new Date() / 1000;
        let expDate = new Date(expiryDate) / 1000;

        if(expDate<=today){
          toast('warning', 'Invalid expiry date!');
          return;
        }

        let testtag = {
        //   provider,
          expiry_date: new Date(expiryDate).toISOString().split('T')[0],
        //   policy_number: policyNumber,
          updated: new Date(new Date().toUTCString()).toISOString().slice(0, 19).replace('T', ' '),
          expired: 0,
          fileId,
        };
        if(doc && doc.id){
          handleUpdateDoc(testtag);
        }else{
          handleAddDoc(testtag);
        }
        
        
      }
      else{
        toast('warning', 'Please fill all the fields!')
        // closeModal();
      }

  }

  const stackStyle = {};
  if(isMobile){
    stackStyle.maxHeight = '90vh';
    stackStyle.overflowY = 'auto';
  }
    
  return (
    <div style={stackStyle}>
            <Typography variant="h4" sx={{ mb: 3 }}>
             {
               editable? "Add your Test & Tag document":"Test & Tag document"
             }
            </Typography>
      <Stack  direction={{ xs: 'column', md: 'row' }}>
          {/* <Paper
            sx={{
              p: 2,
              width: 1,
              position: 'relative',
              border: (theme) => `solid 1px ${theme.palette.grey[500_32]}`,
            }}
            style={{paddingRight: '40px'}}
          > */}
        
        {
          editable?(
            <Grid container spacing={1}>
              <Grid item xs={12} >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker format="dd-MM-yyyy"
                    label="Expiry Date"
                    openTo="day"
                    views={['day','month','year']}
                    value={expiryDate}
                    error={showError && !expiryDate}
                    onChange={(newValue) => {
                      setExpiryDate(newValue);
                    }}
                    slotProps={{ textField: { fullWidth: true } }}
                  />
                </LocalizationProvider>

              </Grid>

              <Grid item xs={12} >
                <DocUploadDropzone
                  label="Upload Document"
                  file={file || doc?.file}
                  toast={toast}
                  onUploaded={(res)=>{ setFileId(res.fileId); setFile(res.url); }}
                />
              </Grid>

          </Grid>
          ):(
            <Typography>Expires: <span style={{ color: '#fda92d' }}>{FDate(expiryDate)}</span></Typography>
          )
        }
           
            
         
          
       
      </Stack>
        {
          editable?(
            <LoadingButton fullWidth variant="contained" loading={loading} disabled={!file && !doc?.file} sx={{mt:2}}
              loadingPosition="start"
              onClick={handleSubmit}
              startIcon={<SaveIcon />}
              >
            {doc?.id ? 'Save changes' : 'Upload'}
          </LoadingButton>
          ):<DocPreview file={doc.file} />
        }

    </div>
  );
}